import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import ReviewsPageContent from './ReviewsPageContent';

const ReviewsPage = props => {
  return (
    <ReviewsPageContent
      thirdPartyServices={props.restaurant.thirdPartyServices}
    />
  );
};

ReviewsPage.propTypes = {
  restaurant: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language
  };
};

export default connect(mapStateToProps)(ContextProvider(ReviewsPage));



// WEBPACK FOOTER //
// ./containers/ReviewsPage/ReviewsPage.js